import { Fragment, useMemo } from 'react';
import { useEffectOnce } from 'react-use';
import cross from '~/assets/icons/cross.svg';
import { playSound, Sound } from '~/assets/sounds';
import { PanelControls } from '~/components/ui/PanelControls';
import { ShopContainer } from '~/components/ui/Shop';
import { ShopBalance } from '~/components/ui/ShopBalance';
import { ShopHead } from '~/components/ui/ShopHead';
import { ShopPreview } from '~/components/ui/ShopPreview';
import { rage, useInputAction } from '~/rage';
import { InputAction, InputKey, WalletType } from '~/shared';
import logo from '../../assets/images/logo.svg';
import { CategoryTab } from '../../components/CategoryTab';
import { ListTab } from '../../components/ListTab';
import { SelectColorPreview } from '../../components/SelectColorPreview';
import { useBuy, useShopPreview } from '../../hooks';
import {
	resetStore,
	setActiveStage,
	StageTypes,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledCloseButtonContainer,
	StyledControlsContainer,
	StyledRightContainer,
} from './BarberShop.styled';

const BarberShop = () => {
	const dispatch = useLayoutDispatch();
	const activeStage = useLayoutSelector(
		(state) => state.barberShop.activeStage,
	);

	const { handleBuy } = useBuy();
	const shopPreview = useShopPreview();

	const leftControls = useMemo(() => {
		if (activeStage === StageTypes.Category) {
			return [
				{
					text: 'Управление',
					keys: [
						InputKey.ArrowUp,
						InputKey.ArrowDown,
						InputKey.ArrowLeft,
						InputKey.ArrowRight,
					],
				},
				{
					text: 'Выбрать категорию',
					keys: [InputKey.Enter],
					onClick: () => dispatch(setActiveStage(StageTypes.List)),
				},
				{
					text: 'Крутить камеру',
					keys: [InputKey.MouseRight],
				},
			];
		}

		if (activeStage === StageTypes.List) {
			return [
				{
					text: 'Управление',
					keys: [InputKey.ArrowUp, InputKey.ArrowDown],
				},
				{
					text: 'Купить',
					keys: [InputKey.Enter],
					onClick: () => handleBuy(WalletType.Cash),
				},
				{
					text: 'Крутить камеру',
					keys: [InputKey.MouseRight],
				},
			];
		}

		return [];
	}, [activeStage, handleBuy]);

	const rightControls = [
		{
			text: 'Выйти',
			keys: ['Esc'],
			onClick: () => rage.barberShop.exitMenu(),
		},
	];

	useInputAction(InputAction.CommonMenuClose, () => rage.barberShop.exitMenu());

	useEffectOnce(() => {
		return () => {
			dispatch(resetStore());
		};
	});

	return (
		<Fragment>
			<StyledRightContainer>
				<ShopBalance />
				<StyledCloseButtonContainer
					onMouseEnter={() => playSound(Sound.LinkCursor)}
					onClick={() => {
						rage.barberShop.exitMenu();
						playSound(Sound.ClickButton);
					}}
				>
					<img src={cross} width={20} height={20} />
				</StyledCloseButtonContainer>
			</StyledRightContainer>
			<ShopContainer>
				<ShopHead img={logo} text={''} height={30} />
				{activeStage === StageTypes.Category && <CategoryTab />}
				{activeStage === StageTypes.List && <ListTab />}
			</ShopContainer>
			<StyledControlsContainer>
				<PanelControls controls={leftControls} align="left" />
				<PanelControls controls={rightControls} align="right" />
			</StyledControlsContainer>
			<ShopPreview {...shopPreview}>
				<SelectColorPreview />
			</ShopPreview>
		</Fragment>
	);
};

export { BarberShop };
